export default __webpack_public_path__ + "media/svgs/send-cf3b82cd.svg";